<script lang="ts">
import Vue from 'vue'
import IMask from 'imask';

export default Vue.extend({
  name: "BirthDatesInput",
  props: {
    birthDates: {
      type: Array,
      default() {
        return [];
      }
    },
    validator: {
      type: Object
    }
  },
  model: {
    prop: 'birthDates',
    event: 'update'
  },
  data() {
    return {
      birthDatesArray: [''],
      popupVisible: false,
      popupWidth: 0,
      submitCheck: false,
      optionsBirthDates: {
        format: 'DD.MM.YYYY',
        useCurrent: false,
        maxDate: new Date(),
        minDate: moment().subtract(100, 'years').subtract(1, 'days').toDate(),
        locale: 'uk',
        icons: {
          previous: 'icon arrow-point-to-left',
          next: 'icon arrow-point-to-right',
        },
      },
    }
  },
  computed: {
    $v: function() {
      return this.validator
    }
  },
  watch: {
    popupVisible(value) {
      if (value) {
        window.addEventListener('click', this.handleClickOutside);
      } else {
        window.removeEventListener('click', this.handleClickOutside);
      }
    },
  },
  methods: {
    datapickerMask(){
      const inputElements = document.querySelectorAll('.datapicker-mask input.form-control.date-input__dp');
      if(inputElements){
        inputElements.forEach((inputElement, index) => {
          IMask(inputElement, {
            mask: '00.00.0000'
          });
        });
      }
    },
    handleClickOutside(event) {
      const multiselectElement = this.$el.querySelector('.multiselect') || null;
      const popupElement = this.$refs.popup;
      const isInsideMultiselect = multiselectElement && (multiselectElement.contains(event.target) || multiselectElement === event.target);
      const isInsidePopup = popupElement && (popupElement.contains(event.target) || popupElement === event.target);

      const isInsideArrow = event.target.classList.contains('multiselect__select');
      if (!isInsideMultiselect && !isInsidePopup && !isInsideArrow) {
        this.popupVisible = false;
      }
    },
    formatDate(date) {
      return date ? moment(date, 'DD.MM.YYYY').format('DD.MM.YYYY') : '';
    },
    togglePopup(event) {
      event.stopPropagation();
      this.popupVisible = !this.popupVisible;
      this.setPopupWidth();
    },
    handleArrowClick(event) {
      this.togglePopup();
    },
    setPopupWidth() {
      this.popupWidth = this.$refs.multiselect.offsetWidth;
    },
    handlePopupClick(event) {
      event.stopPropagation();
    },
    updateBirthDates(event) {
      if (event !== '') {
        this.$emit('update', this.birthDatesArray.filter(item => item !== ''))
      }
    },
    addClient() {
      this.birthDatesArray.push('')
    },
    removeClient(index) {
      this.birthDatesArray.splice(index, 1);
      this.$emit('update', this.birthDatesArray.filter(item => item !== ''))
    }
  },
  mounted() {
    this.datapickerMask()
  }
})
</script>

<template>
  <div>
    <div class="form-group d-flex flex-column flex-grow-1" @click="togglePopup"
         ref="multiselect">
      <label>Кількість та вік туристів</label>
      <div :class="['form-control  align-items-center position-relative multiselect multiselect_block',  {invalid: !$v.birthDates.required && $v.birthDates.$dirty}]">
                                      <span v-if="birthDates.length > 0" v-for="(client, index) in birthDates"
                                            :key="index" class="selected-client">
                                        {{ formatDate(client) }}
                                        <span class="remove-button" @click.stop="removeSelectedClient(index)"><svg
                                          width="12" height="12" viewBox="0 0 12 12" fill="none"
                                          xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 10.9214L10.7879 0.999865" stroke="#0076B2" stroke-width="1.5"
                                              stroke-linecap="round"/>
                                        <path d="M1.2121 1.07861L11 11.0001" stroke="#0076B2" stroke-width="1.5"
                                              stroke-linecap="round"/>
                                    </svg></span>
                                      </span>
        <span class="client_pleaseholder" v-if="birthDates.length == 0">
                                        {{ 'Вкажіть кількість та вік' }}
                                    </span>
        <div class="multiselect__select" :class="{'multiselect__arrow': popupVisible}"
             @click="handleArrowClick"></div>
      </div>
      <small class="error" v-if="!$v.birthDates.required && $v.birthDates.$dirty">Bкажіть хоча б одну людину</small>
    </div>

    <div class="popup datapicker-mask" :style="{ width: popupWidth + 'px' }" v-show="popupVisible" ref="popup"
         @click="handlePopupClick">
      <div v-for="(client, index) in birthDatesArray" :key="index" class="client-row">
        <span class="client_number"><b>Учасник {{ index + 1 }}</b></span>
        <date-picker
          v-model="birthDatesArray[index]"
          @input="updateBirthDates"
          :config="optionsBirthDates"
          class="date-input__dp"
          placeholder="Дата народження"
          ref="test2"
        >
          <template #input="{ value }">
            <input
              :ref="'birthInput_' + index"
              :value="value"
              type="text"
              class="form-control date-input__dp"
              placeholder="Дата народження"
            >
          </template>
        </date-picker>

        <button @click="removeClient(index)" class="remove-button">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 10.9214L10.7879 0.999865" stroke="#0076B2" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M1.2121 1.07861L11 11.0001" stroke="#0076B2" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      <a @click="addClient" class="add-client"><b>+ Додати ще учасника</b></a>
    </div>
  </div>
</template>

<style scoped lang="scss">
.selected-client {
  display: inline-block;
  background-color: #BFDDEC;
  border-radius: 25px !important;
  color: #0076B2;
  font-size: 14px;
  padding: 0 14px;
  margin: 10px -2px 4px 4px;
  position: relative;
  z-index: 2;
}
.client-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.active-input {
  border-color: #ffad3d;
}
.add-client {
  display: block;
  margin-top: 10px;
  cursor: pointer;
  width: 170px;
}
.remove-button {
  background: none;
  border: none;
  color: red;
  cursor: pointer;
}
.multiselect__arrow {
  transition: all .2s;
  transform: rotate(180deg);
  right: 5px !important;
}
.date-input__dp {
  min-height: 42px;
  background-image: url(~@/assets/images/icons/date-icon.svg);
  background-size: 18px;
  background-repeat: no-repeat;
  background-position: right 11px bottom 11px;
}
.client-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.multiselect_block {
  height: auto;
}

.multiselect_block .multiselect__arrow {
  background: transparent !important;
}
.remove-button {
  margin-left: 4px;
  color: black;
  cursor: pointer;
}
.popup {
  position: absolute;
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 10px;
  z-index: 999;
  box-shadow: 0 0 12px 0 rgba(100, 100, 100, 0.5);
  border-radius: 3px;
}
.client_number {
  margin-right: 10px;
  width: 124px;
}

.client_pleaseholder {
  display: block;
  position: relative;
  margin-top: 9px;
  margin-left: 10px;
  color: #ACAFB6;
}
</style>
